import React, { useState, useContext } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import Grid from '@mui/material/Grid';
import { SelectContractContent, SelectContractTitle, SelectContractText, SelectContractCloseButton, SelectModifyButton, ConstrustBaseButton } from '../../css/CSS.js';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import useAuthAxios from "../../../useAuthAxios";
import { useNavigate } from 'react-router-dom';
import LoadingDialog from '../../Loading';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { DigitalConstractsContext } from "../../../DigitalConstracts";

export default function DigitalConstractSelectContract(props) {
    const headers = { "Authorization": "Bearer " + localStorage.getItem("Auth"), };


    const [open, setOpen] = React.useState(false);
    const authAxios = useAuthAxios();
    const [contract, setContract] = useState()
    const [changeContract, setChangeContract] = useState(false)
    const navigate = useNavigate();
    const [processing, setProcessing] = useState(false);
    const [onlyConstract, setOnlyConstract] = useState(false);
    const [selectBase, setSelectBase] = useState(false);
    const [selectModify, setSelectModify] = useState(false);
    const [constructsBase, setConstructsBase] = React.useState("");
    const [constructsModfiy, setConstructsModify] = React.useState("");
    const { setKojiCD, setSeqNo, setContractName, setContractType, setStatus, setStatusCheck } = useContext(DigitalConstractsContext);
    const [constructionBaseName, setConstructionBaseName] = useState(props.ConstructionName ?? '');
    const [constructionModifyName, setConstructionModifyName] = useState(props.ConstructionName ?? '');

    React.useLayoutEffect(() => {
        if (props.open === false) { return }
        if (props.open === true) {
            setStatusCheck(false)
            setProcessing(true)
            authAxios
                .get('api/contracts/contracts?'
                    + 'kojiCD=' + props.KojiCD + '&concluded=1'
                    , { headers }
                )
                .then(response => {
                    if (response.status === 200) {
                        const listdata = JSON.parse((JSON.stringify(response.data)))
                        setContract(listdata)
                        if (listdata.contractList.length === 1) {
                            setOnlyConstract(true)
                        }
                        else {
                            setChangeContract(true)
                        }
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        alert("認証情報が正しくありません。");
                        navigate("/");
                    } else {
                        alert("契約書情報の取得に失敗しました。");
                    }
                });

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.open]);

    React.useLayoutEffect(() => {
        if (onlyConstract === true) {
            contract.contractList?.forEach((row) => {
                if (row.contractType === "工事請負契約書") { setSelectBase(true) }
                else if (row.contractType === "変更工事請負契約書") { setSelectModify(true) }
                setOnlyConstract(false)
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [onlyConstract]);


    const handleClose = () => {
        setOpen(false);
        setConstructsBase("")
        setConstructsModify("")
        props.close(false)
    };


    React.useEffect(() => {
        setOpen(props.open);
    }, [props.open]);

    React.useEffect(() => {
        if (changeContract === true) {
            contract.contractList?.forEach((row) => {
                if (row.contractType === "工事請負契約書") {
                    setConstructsBase(row.status);
                    setConstructionBaseName(row.constructionName);
                }
                else if (row.contractType === "変更工事請負契約書") {
                    setConstructsModify(row.status);
                    setConstructionModifyName(row.constructionName);
                }
            })
            setProcessing(false)
            setChangeContract(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [changeContract]);

    const handleSelectBase = () => {
        if (selectBase === true) { return }
        else {
            setSelectBase(true)
        }
    };

    React.useEffect(() => {
        if (selectBase === true) {
            contract.contractList?.forEach((row) => {
                if (row.contractType === "工事請負契約書") {
                    setKojiCD(row.kojiCD)
                    setSeqNo(row.seqNo)
                    setContractName(row.constructionName)
                    setContractType(row.contractType)
                    setStatus(row.status)
                    navigate("/digitalconstract?kojiCD=" + row.kojiCD + "&costructtype=" + (row.contractType === "工事請負契約書" ? "base" : "modfy") + "&seqno=" + row.seqNo);
                }
            })
            setStatusCheck(true)
            setSelectBase(false)
            setOpen(false)
            props.close(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectBase]);

    const handleSelectModify = () => {
        if (selectModify === true) { return }
        else {
            setSelectModify(true)
        }
    };

    React.useEffect(() => {
        if (selectModify === true) {
            contract.contractList?.forEach((row) => {
                if (row.contractType === "変更工事請負契約書") {
                    setKojiCD(row.kojiCD)
                    setSeqNo(row.seqNo)
                    setContractName(row.constructionName)
                    setContractType(row.contractType)
                    setStatus(row.status)
                    navigate("/digitalconstract?kojiCD=" + row.kojiCD + "&costructtype=" + (row.contractType === "工事請負契約書" ? "base" : "modfy") + "&seqno=" + row.seqNo);
                }
            })
            setStatusCheck(true)
            setSelectModify(false)
            setOpen(false)
            props.close(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectModify]);
    
    return (
        <React.Fragment>
            <Dialog
                open={open}
                onClose={handleClose}
                maxWidth="md"
            >
                <LoadingDialog load={processing} />
                <SelectContractTitle >
                    契約書選択
                </SelectContractTitle>
                <SelectContractContent>
                    <Grid container columns={12} sx={{ pt: 3 }} alignItems="center" spacing={1}>
                        <Grid item >
                            <Typography sx={{ fontSize: 20 }}>
                                工事コード
                            </Typography>
                        </Grid>
                        <Grid item >
                            <Box sx={{ backgroundColor: '#fff', px: 3, py: 0.5 }}>
                                <Typography sx={{ fontSize: 20 }}>{props.KojiCD}</Typography>
                            </Box>
                        </Grid>
                    </Grid>
                    <Grid container columns={12} rowSpacing={3} sx={{ pt: 3 }}>
                        <Grid item container>
                            <Grid item container direction="column" style={{ display: 'flex', justifyContent: 'start', alignItems: 'center' }} alignItems="stretch" rowSpacing={1}>
                                <Grid item sx={{ width: '100%' }}>
                                    <ConstrustBaseButton type="button" onClick={() => handleSelectBase()} fullWidth style={{ borderRadius: "5px 5px 0 0", border: 'none' }}>
                                        <Typography size="large" sx={{ px: 3, py: 0.5, fontSize: 23 }}>工事請負契約書</Typography>
                                    </ConstrustBaseButton>
                                </Grid>
                            </Grid>
                            <Grid container item>
                                <Grid item sx={{ width: '100%' }} xs={8}>
                                    <Box sx={{ backgroundColor: "#ffffff", p: 2, display: "flex", alignItems: "center", height: '100%' }}>
                                        <Typography size="large" >{constructionBaseName}
                                        </Typography>
                                    </Box>
                                </Grid>
                                <Grid item alignItems="center" sx={{ width: '100%' }} xs={4}>
                                    <SelectContractText style={{ backgroundColor: "#eaffea", height: '100%', display: "flex", alignItems: "center" }}>
                                        <Typography style={{ fontSize: 20 }} >{constructsBase === "" ? "未作成" : constructsBase} </Typography>
                                    </SelectContractText>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item container>
                            <Grid item container direction="column" style={{ display: 'flex', justifyContent: 'start', alignItems: 'center' }} alignItems="stretch" rowSpacing={1}>
                                <Grid item sx={{ width: '100%' }}>
                                    <SelectModifyButton type="button" size="large" onClick={() => handleSelectModify()} fullWidth style={{ borderRadius: "5px 5px 0 0", border: 'none' }}>
                                        <Typography size="large" sx={{ px: 3, py: 0.5, fontSize: 23 }}>変更工事請負契約書</Typography>
                                    </SelectModifyButton>
                                </Grid>
                            </Grid>
                            <Grid container item>
                                <Grid item sx={{ width: '100%' }} xs={8}>
                                    <Box sx={{ backgroundColor: "#ffffff", p: 2, display: "flex", alignItems: "center", height: '100%' }}>
                                        <Typography size="large" >{constructionModifyName}
                                        </Typography>
                                    </Box>
                                </Grid>
                                <Grid item alignItems="center" sx={{ width: '100%' }} xs={4}>
                                    <SelectContractText style={{ backgroundColor: "#eaffea", height: '100%', display: "flex", alignItems: "center" }}>
                                        <Typography style={{ fontSize: 20 }} >{constructsModfiy === "" ? "未作成" : constructsModfiy} </Typography>
                                    </SelectContractText>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </SelectContractContent>
                <DialogActions style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <SelectContractCloseButton type="button" onClick={handleClose}>キャンセル<KeyboardReturnIcon sx={{ ml: 1 }} /></SelectContractCloseButton>
                </DialogActions>
            </Dialog>
        </React.Fragment >
    );
}